import { render, staticRenderFns } from "./EventsLive.vue?vue&type=template&id=cba0bf34&scoped=true&"
import script from "./EventsLive.vue?vue&type=script&lang=js&"
export * from "./EventsLive.vue?vue&type=script&lang=js&"
import style0 from "./EventsLive.vue?vue&type=style&index=0&id=cba0bf34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0bf34",
  null
  
)

export default component.exports